import React from 'react';
import styles from '../../pages/detailPage/DetailPage.scss';
import 'react-table/react-table.css'
import ReactTable from 'react-table';
import '@amzn/awsui-components-react/index.css';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'actions';

import PropTypes from 'prop-types';

export class ExecutionDashboard extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.downloadUrl !== this.props.downloadUrl) {
      const { downloadUrl } = this.props;

      if (downloadUrl != '') {
        window.open(downloadUrl);
      }
    }
  }

  static propTypes = {
    error: PropTypes.string,
    downloading: PropTypes.bool,
    downloadSource: PropTypes.func,
  };

  handleSourceData(run_id, calculation) {
    const { downloadSource } = this.props;
    downloadSource("/downloadSource/" + run_id + "_source.csv");
  }

  handleTransformedData = (run_id, calculation) => {
    const { downloadSource } = this.props;
    downloadSource("/downloadSource/" + run_id + "_transformed.csv");
  }

  getDetail = (sourceList) => {
    let details = [];
    for (let i = 0; i < sourceList.length; i++) {
      const row = sourceList[i];
      let newDetail = {
        id: row.id,
        agreementNumber: row.agreementNumber,
        calculation: row.categoryName,
        period: row.periodName,
        netIssueAmount: row.netIssueAmount,
        runDate: row.transformDate,
        targetSystem: "Virtual Trader",
        targetSystemPeriod: row.periodName,
        status: row.status,
        sourceFileName: row.sourceFileName,
        transformedFileName: row.transformedFileName,
      }

      details = [...details, newDetail]
    }

    return details;
  }

  decimalFormatter = (value) => {
    if (value === null || value === undefined) {
      return null;
    }
    const result = value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    return value < 0 ? `(${result.substring(1)})` : result;
  };

  countDecimals = (value) => {
    let text = value.toString()
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf('e-') > -1) {
      let [base, trail] = text.split('e-');
      let deg = parseInt(trail, 10);
      return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== Number.parseFloat(value)) {
      return value.toString().split(".")[1].length || 0;
    }
    return 0;
  };

  render() {

    let columnItems = [
      {
        Header: 'Run id',
        accessor: 'id',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Agreement Number',
        accessor: 'agreementNumber',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Calculation',
        accessor: 'calculation',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Period',
        accessor: 'period',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Net Issue Amount',
        accessor: 'netIssueAmount',
        width: 130,
        headerClassName: styles.leftAlignContent,
        Cell: cellInfo => {
          const valueList = JSON.parse(cellInfo.value);
          //let num = Number.parseFloat(cellInfo.value);
          let displayValue = "| ";
          valueList.forEach(num => {
            const numDecimals = this.countDecimals(num);
            if (numDecimals < 2) {
              num = num.toFixed(2);
            }
            displayValue += this.decimalFormatter(num) + " | "
          });

          return <span>{displayValue}</span>
        }
      },
      {
        Header: 'Run Date',
        accessor: 'runDate',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Target System',
        accessor: 'targetSystem',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Target System Period',
        accessor: 'targetSystemPeriod',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 130,
        headerClassName: styles.leftAlignContent
      },
      {
        Header: 'Source Data',
        width: 130,
        headerClassName: styles.leftAlignContent,
        Cell: ({ row, Original }) => <a href='#' onClick={(e) => {
          e.preventDefault();
          this.handleSourceData(row.id, row.sourceFileName);
        }}>Download Source Data</a>
      },
      {
        Header: 'Transformed Data',
        width: 130,
        headerClassName: styles.leftAlignContent,
        Cell: ({ row, Original }) => <a href='#' onClick={(e) => {
          e.preventDefault();
          this.handleTransformedData(row.id, row.transformedFileName);
        }}>View Transformed Data</a>
      },
    ];
    return (
      <div className="awsui-util-container">
        <div className="awsui-util-container-header">
          <h2 className="awsui-util-font-size-3">Execution History</h2>
        </div>
        <React.Fragment>
          <div data-awsui-column-layout-root>
            <ReactTable
              data={this.props.initialized[this.props.id] ? this.getDetail(this.props.iCData[this.props.id]): []}
              minRows={0}
              columns={columnItems}
              sortable
              defaultSorted={[
                {
                  id: "runDate",
                  desc: true
                }
              ]}
              loading={this.props.loading}
              loadingText="Searching..."
              resizableColumns
              showPagination={false}
              noMatch="noMatchContent"
            />
          </div>
        </React.Fragment>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  const {fetchICData} = state;
  const {
    loading,
    iCData,
    error,
    initialized,
  } = fetchICData;

  const { downloadSource } = state;
  const {
    downloading,
    downloadUrl,
    downloadError,
  } = downloadSource;

  return {
    downloading: downloading,
    downloadError: downloadError,
    downloadUrl: downloadUrl,
    loading: loading,
    iCData: iCData,
    initialized: initialized
  };
};

const mapDispatchToProps = {
  downloadSource: actions.downloadSource,
};

const ExecutionDashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExecutionDashboard);

export default withRouter(ExecutionDashboardContainer);